import { render, staticRenderFns } from "./EffectPicture.vue?vue&type=template&id=6a6bcb28&scoped=true&"
import script from "./EffectPicture.vue?vue&type=script&lang=js&"
export * from "./EffectPicture.vue?vue&type=script&lang=js&"
import style0 from "./EffectPicture.vue?vue&type=style&index=0&id=6a6bcb28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6bcb28",
  null
  
)

export default component.exports